import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TAiAssistantState } from './aiAssistant.type';
import { TOneBoxV3GetRecommendSettings } from '~/api/oneBoxV3/oneBoxV3.type';
import { oneBoxV3Api } from '~/api/oneBoxV3';
import { RecommendMethod } from '~/components/AiPopup/AiDialog';

const initialState: TAiAssistantState = {
  recommendSetting: {
    disabled: false,
    createdAt: '',
    updatedAt: '',
    _id: '',
    userId: '',
    resourceConfigs: [],
    popUp: {
      isFeatureEnabled: false,
      reminderPeriod: 'always',
      isDisplayPaused: false,
      pauseStartDate: '',
      pauseEndDate: '',
    },
    weekAdjust: {
      userYear: '',
      userSemester: '',
      userWeek: 1,
    },
    displayWeekInfos: {
      currentYear: '',
      currentSemester: '',
      currentWeek: 0,
      weekStart: '',
      weekEnd: '',
      lastWeek: 0,
      userDisplayWeek: 0,
      userDisplayWeekStart: '',
      userDisplayWeekEnd: '',
    },
  },
  resources: [],
  toAllRecommend: false,
  selectedIndex: 0, // 學制年級科目 tab 的 index
  recommendMethod: RecommendMethod.CUSTOMIZED,
  openSettingDialog: false,
};

export const AiAssistantSlice = createSlice({
  name: 'aiAssistant',
  initialState,
  reducers: {
    setRecommendSetting: (
      state,
      action: PayloadAction<TOneBoxV3GetRecommendSettings>,
    ) => {
      state.recommendSetting = action.payload;
    },
    setUserDisplayWeek: (
      state,
      action: PayloadAction<{
        userDisplayWeek: number;
        userDisplayWeekStart: string;
        userDisplayWeekEnd: string;
      }>,
    ) => {
      state.recommendSetting.displayWeekInfos.userDisplayWeek =
        action.payload.userDisplayWeek;
      state.recommendSetting.displayWeekInfos.userDisplayWeekStart =
        action.payload.userDisplayWeekStart;
      state.recommendSetting.displayWeekInfos.userDisplayWeekEnd =
        action.payload.userDisplayWeekEnd;
    },
    setSelectedIndex: (state, action: PayloadAction<number>) => {
      state.selectedIndex = action.payload;
    },
    setRecommendMethod: (state, action: PayloadAction<RecommendMethod>) => {
      state.recommendMethod = action.payload;
    },
    setToAllRecommend: (state, action: PayloadAction<boolean>) => {
      state.toAllRecommend = action.payload;
    },
    setOpenSettingDialog: (state, action: PayloadAction<boolean>) => {
      state.openSettingDialog = action.payload;
    },
    resetRecommendSetting: state => {
      //eslint-disable-next-line @typescript-eslint/no-unused-vars
      state = { ...initialState };
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      oneBoxV3Api.endpoints.getRecommendSettings.matchFulfilled,
      (state, action) => {
        if (!action.payload.data?.popUp) {
          const data = action.payload.data || initialState.recommendSetting;
          state.recommendSetting = {
            ...data,
            popUp: initialState.recommendSetting.popUp,
          };
          return;
        }
        state.recommendSetting =
          action.payload.data || initialState.recommendSetting;
      },
    );
  },
});

export const {
  // setAiSearchCondition,
  setToAllRecommend,
  setRecommendSetting,
  setUserDisplayWeek,
  setSelectedIndex,
  setRecommendMethod,
  setOpenSettingDialog,
  resetRecommendSetting,
} = AiAssistantSlice.actions;

export default AiAssistantSlice.reducer;
